import React from "react";
import "./Services.css";
import { FaBalanceScale, FaLightbulb, FaGavel } from "react-icons/fa";

const Servicos = () => {
  return (
    <section className="servicos" id="servicos">
      <div className="servicos-container">
        <h2 className="servicos-title">Serviços Ofertados</h2>

        <div className="servicos-grid">
          {/* ASSESSORIA JURÍDICA */}
          <div className="servico-card servico-destaque">
            <FaBalanceScale className="servico-icon" />
            <h3>Assessoria Jurídica</h3>

            <p>
              A assessoria jurídica empresarial tem como objetivo oferecer
              suporte estratégico e preventivo às empresas, auxiliando na
              tomada de decisões seguras e alinhadas à legislação vigente.
            </p>
            <p>
              A atuação é voltada à prevenção de riscos jurídicos, à redução de
              passivos e ao fortalecimento da conformidade legal nas rotinas
              corporativas.
            </p>
            <p>
              O trabalho envolve orientação contínua em questões trabalhistas,
              contratuais e legais do dia a dia empresarial, elaboração e
              revisão de contratos, adequação de procedimentos internos,
              acompanhamento de demandas judiciais e consultoria personalizada
              conforme as necessidades do negócio.
            </p>
          </div>

          {/* CONSULTORIA JURÍDICA */}
          <div className="servico-card">
            <FaLightbulb className="servico-icon" />
            <h3>Consultoria Jurídica</h3>

            <p>
              Análise técnica de situações específicas, com orientação
              personalizada para esclarecimento de dúvidas, indicação de
              caminhos legais e apoio à tomada de decisões de forma segura e
              fundamentada.
            </p>
          </div>

          {/* ADVOCACIA CONTENCIOSA */}
          <div className="servico-card">
            <FaGavel className="servico-icon" />
            <h3>Advocacia Contenciosa</h3>

            <p>
              Representação do cliente em processos judiciais e administrativos,
              com elaboração de peças, atuação em defesa ou reclamatória
              trabalhista, participação em audiências e condução estratégica da
              demanda até sua resolução.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Servicos;
